import React, { FC } from "react";

import { Grid, useTheme } from "@mui/material";
import { ProductFilterList } from "@src/components/MainApp/SharedProductPicker/filters/ProductFilterList";
import { ProductSearch } from "@src/components/MainApp/SharedProductPicker/filters/ProductSearch";

export const ProductFilters = ({
  allowIgProducts,
}: {
  allowIgProducts?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Grid padding={5} item container direction={"column"} rowSpacing={5}>
      <Grid item>
        <ProductSearch />
      </Grid>
      <Grid item>
        <ProductFilterList allowIgProducts={allowIgProducts} />
      </Grid>
    </Grid>
  );
};
